export const defaultStyles = {
  "tint-text-dark": "#16161a",
  "tint-text-light": "#ffffff",
  "tint-tab-color": "#16161a",

  "tint-progress-color": "#4ccc75",
  "tint-face-analysis-badge-color": "#f9b74a",
  "tint-face-analysis-badge-radius": "8px",
  "tint-face-analysis-color": "#ffffff",
  "tint-face-analysis-no-light-color": "#ffbb44",
  "tint-face-analysis-ok-color": "#11eeaa",

  "tint-mobile-fab-background": "rgba(0, 0, 0, .25)",
  "tint-mobile-fab-radius": "8px",

  "tint-button-primary-background": "#16161a",
  "tint-button-primary-background-hover": "#39393c",
  "tint-button-primary-background-active": "#515154",
  "tint-button-primary-background-disabled": "#b9b9ba",

  "tint-button-secondary-background": "#efefef",
  "tint-button-secondary-background-hover": "#e7e7e7",
  "tint-button-secondary-background-active": "#dfdfdf",
  "tint-button-secondary-background-disabled": "#f7f7f7",

  "tint-button-primary-text": "#ffffff",
  "tint-button-primary-text-hover": "#ffffff",
  "tint-button-primary-text-active": "#ffffff",
  "tint-button-primary-text-disabled": "#ffffff",

  "tint-button-secondary-text": "#16161a",
  "tint-button-secondary-text-hover": "#16161a",
  "tint-button-secondary-text-active": "#16161a",
  "tint-button-secondary-text-disabled": "#16161a",

  "tint-button-primary-border": "#ffffff",
  "tint-button-primary-border-hover": "#ffffff",
  "tint-button-primary-border-active": "#ffffff",
  "tint-button-primary-border-disabled": "#ffffff",

  "tint-button-secondary-border": "#ffffff",
  "tint-button-secondary-border-hover": "#ffffff",
  "tint-button-secondary-border-active": "#ffffff",
  "tint-button-secondary-border-disabled": "#ffffff",

  "tint-button-primary-border-width": "0px",
  "tint-button-primary-border-width-hover": "0px",
  "tint-button-primary-border-width-active": "0px",
  "tint-button-primary-border-width-disabled": "0px",

  "tint-button-secondary-border-width": "0px",
  "tint-button-secondary-border-width-hover": "0px",
  "tint-button-secondary-border-width-active": "0px",
  "tint-button-secondary-border-width-disabled": "0px",

  "tint-button-sm-radius": "18px",
  "tint-button-base-radius": "18px",
  "tint-button-lg-radius": "26px",

  "tint-item-badge-recommended": "#0fa429",
  "tint-item-badge-applied": "#16161a",

  "tint-item-badge-recommended-text": "#ffffff",
  "tint-item-badge-applied-text": "#ffffff",

  "tint-item-badge-radius": "999px",

  "tint-item-border": "#dcdcdd",
  "tint-item-border-hover": "#737376",
  "tint-item-border-applied": "#16161a",

  "tint-navbar-background": "#16161a",
  "tint-notification-background": "#38383c",

  "tint-font-root": "Nunito Sans",
  "tint-font-h1": "Nunito Sans",
  "tint-font-h2": "Nunito Sans",
  "tint-font-h3": "Nunito Sans",
  "tint-font-h4": "Nunito Sans",
  "tint-font-h5": "Nunito Sans",
  "tint-font-h6": "Nunito Sans",
  "tint-font-button": "Nunito Sans",

  "tint-font-root-weight": "400",
  "tint-font-h1-weight": "700",
  "tint-font-h2-weight": "700",
  "tint-font-h3-weight": "700",
  "tint-font-h4-weight": "700",
  "tint-font-h5-weight": "700",
  "tint-font-h6-weight": "700",
  "tint-font-button-weight": "700",

  "tint-font-root-style": "normal",
  "tint-font-h1-style": "normal",
  "tint-font-h2-style": "normal",
  "tint-font-h3-style": "normal",
  "tint-font-h4-style": "normal",
  "tint-font-h5-style": "normal",
  "tint-font-h6-style": "normal",
  "tint-font-button-style": "normal",
}
